import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {useSelector} from "react-redux";

export default function BlockUI() {
    const config = useSelector((store) => store.app);

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={config.blockUI.open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}